<form id="busy-form" action="#" method="POST" soho-busyindicator [transparentOverlay]="transparentOverlay"
    [blockUI]="true" [text]="message" [displayDelay]="delay" autocomplete="off">
    <div id="notification">
    </div>
    <div class="row" style="padding-top:2%; padding-left:2%;">
        <h2 class="fieldset-title" style="font-size: x-large;">{{ProjectTitle}}</h2>
    </div>
    <div class="row">
        <div class="twelve columns">
            <div class="row">
                <div class="six columns" style="padding-left: 4%;padding-top: 3%;">
                    <div class="field" id="divFiscalYear">
                        <label id="lblFiscalYear" class="required" for="FiscalYear"
                            >FiscalYear:</label>
                        <select id="FiscalYear" soho-dropdown name="FiscalYear" [(ngModel)]="model.fiscalyear"
                            (change)="RemoveError('FiscalYear')">
                            <option value="-1" selected="">--Select--</option>
                            <option value="FY20" selected="">FY20</option>
                            <option value="FY20SY" selected="">FY20SY</option>
                            <option value="CY21" selected="">CY21</option>
                            <option value="CY22" selected="">CY22</option>
                            <option value="CY23" selected="">CY23</option>
                            <option value="CY24" selected="">CY24</option>
                            <option value="CY25" selected="">CY25</option>
                            <option value="CY26" selected="">CY26</option>
                            <option value="CY27" >CY27</option>
                        </select>
                    </div>
                    <div class="field" id="divUploadTypes">
                        <label id="lblUploadTypes" class="required" for="UploadTypeID"
                            [title]="UploadTypeToolTip">Upload Type:</label>
                        <select id="UploadTypeID" soho-dropdown name="UploadTypeID" [(ngModel)]="model.uploadtypeid"
                            (change)="RemoveError('UploadTypeID')">
                            <option value="-1" selected="">--Select--</option>
                            <option value="1005" selected="">Hardware Rep</option>
                            <option value="1006" selected="">Nexus SAM</option>
                            <option value="1010" selected="">Partner Business Development Plan</option>
                            <option value="1008" selected="">Software Bookings MBO Plan</option>
                            <option value="1007" selected="">TSE Plans</option>                  
                            <!-- <option value="1009" selected="">CM Custom Plan</option> -->                             
                        </select>
                    </div>
                    <div class="field" id="divUpload">
                        <label id="lblFileUpload" for="file-input" class="required">File upload (.xlsx)</label>
                        <!-- <input type="file" class="fileupload" id="file-input" name="file-input" accept=".csv" (change)="SetFile($event)"> -->
                        <input soho-fileupload id="file-input" name="file-input" accept=".xlsx"
                            (change)="SetFile($event)" />
                    </div>
                    <div class="field" id="divUploadButton">
                        <button class="btn-primary hide-focus" type="button" (click)="UploadFile()">Upload XLSX File</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">

    </div>
    <div class="row" id="divUpdate" style="display: none;">
        <input type="button" id="btnBusy" (click)="LoadBusyIndicator()" style="display: none;">
    </div>
</form>

